import { Component, OnInit, ViewChild } from '@angular/core';

import { CustomStore, ArkUnitOfWork, BreezeDxStoreService, AppInformationService } from 'app/core/core.module';
import { ActivatedRoute, Router } from '@angular/router';
import { Predicate, Entity, EntityState } from 'breeze-client';
import { DevExtremeModule, DxDataGridComponent } from 'devextreme-angular';
import { confirm, alert, custom } from 'devextreme/ui/dialog';
import { Guid } from 'app/core/data/entities';

@Component({
    selector: 'app-groups',
    templateUrl: './groups.component.html',
    styleUrls: ['./groups.component.css'],
    imports: [DevExtremeModule]
})
export class GroupsComponent implements OnInit {
    groupStore: any[];
    people: CustomStore;
    dialogPeople: CustomStore;
    popupVisible = false;
    selectedGroupId: Guid;
    groupDialogVisible = false;
    selectedGroupName: any;

    @ViewChild('groupGrid') groupGrid: DxDataGridComponent;
    @ViewChild('groupPeopleGrid') groupPeopleGrid: DxDataGridComponent;
    @ViewChild('unselectedPeopleGrid') unselectedPeopleGrid: DxDataGridComponent;
    groupEdit: any;

    constructor(
        private uow: ArkUnitOfWork,
        private storeService: BreezeDxStoreService,
        public appInfo: AppInformationService,
        private route: ActivatedRoute,
        private router: Router
    ) {}

    ngOnInit() {
        this.getGroups();
    }

    async getGroups() {
        this.groupStore = await this.uow.groups.all('name');
    }

    getPeopleStore() {
        const query = this.uow.groupPersons.baseQuery().where('groupId', '==', this.selectedGroupId).expand('person');
        this.people = this.storeService.createStore(this.uow, this.uow.people, query, 'id', 'person.lastName,person.firstName');
    }

    async editGroup(key) {
        if (!key) {
            this.groupEdit = this.uow.groups.createEntity();
        } else {
            this.groupEdit = await this.groupGrid.instance.byKey(key);
        }
        this.groupDialogVisible = true;
    }

    groupDialogHidden(e) {
        console.log('groupDialogHidden', e);
        this.uow.rollback();
    }

    getDialogPeopleStore() {
        const notSelected = new Predicate('groupPersons', 'any', 'groupId', '==', this.selectedGroupId).not();
        const query = this.uow.people.baseQuery().where(notSelected);

        this.dialogPeople = this.storeService.createStore(this.uow, this.uow.people, query, 'id');
    }

    async gridRowRemoved(e) {
        // console.log(e);
        // const entity: Entity = e.data;
        // if (entity.entityAspect.entityState === EntityState.Added) {
        //     entity.entityAspect.setDetached();
        // } else {
        //     entity.entityAspect.setDeleted();
        // }
        // await this.uow.commit();
    }

    // async gridRowUpdated(e) {
    //     console.log(e);
    //     await this.uow.commit();
    // }

    async saveGroup() {
        await this.uow.commit();
        this.getGroups();
        this.groupDialogVisible = false;
    }

    async onGroupSelectionChanged(e) {
        // this.selectedGroupId = e.currentSelectedRowKeys[0];
        this.selectedGroupId = this.groupGrid.focusedRowKey;
        this.selectedGroupName = this.groupStore.find((x) => x.id === this.selectedGroupId).name;
        if (this.selectedGroupId) {
            this.getPeopleStore();
        } else {
            this.people = null;
        }
    }

    addToGroup() {
        this.getDialogPeopleStore();
        this.popupVisible = true;
    }

    async removeFromGroup() {
        const dialogResult = await (<Promise<boolean>>confirm('Are you sure you want to remove these people from the group?', 'Remove from Group'));
        if (!dialogResult) return;

        const selectGroupPersons = await this.groupPeopleGrid.instance.getSelectedRowsData();
        selectGroupPersons.forEach((groupPerson) => {
            groupPerson.entityAspect.setDeleted();
        });
        await this.uow.commit();
        this.groupPeopleGrid.instance.clearSelection();
        this.groupPeopleGrid.instance.refresh();
    }

    async addSelectedPeople() {
        this.popupVisible = false;
        const selectPeopleIds = this.unselectedPeopleGrid.instance.getSelectedRowKeys();
        this.unselectedPeopleGrid.instance.clearSelection();
        selectPeopleIds.forEach((id) => {
            this.uow.groupPersons.createEntity({ personId: id, groupId: this.selectedGroupId });
        });
        await this.uow.commit();
        this.groupPeopleGrid.instance.refresh();
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            }
        );
    }

    onDialogToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            template: 'dialogButtons',
        });
    }
}
